import axios from '@/libs/api.request';
import store from '@/store';

export const getTableData = () => {
  return axios.request({
    url: 'get_table_data',
    method: 'get'
  })
}

export const getDragList = () => {
  return axios.request({
    url: 'get_drag_list',
    method: 'get'
  })
}

export const errorReq = () => {
  return axios.request({
    url: 'error_url',
    method: 'post'
  })
}

export const saveErrorLogger = info => {
  return axios.request({
    url: 'save_error_logger',
    data: info,
    method: 'post'
  })
}

export const uploadImg = formData => {
  return axios.request({
    url: 'image/upload',
    data: formData
  })
}

export const getOrgData = () => {
  return axios.request({
    url: 'get_org_data',
    method: 'get'
  })
}

export const getTreeSelectData = () => {
  return axios.request({
    url: 'get_tree_select_data',
    method: 'get'
  })
}

export const setScore = (type, resumeId) => {
  return axios.request({
    method: 'post',
    url: `front/v1/company-score/add`,
    data: {
      scoreType: type,
      targetUserId: store.getters.talkUserId ? parseInt(store.getters.talkUserId.split('acftu_test_')[1]) : undefined,
      resumeId: resumeId
    }
  });
};
